/**
 * Situação do cliente que vem da identificação do agendamento público (consulta por CPF ou
 * e-mail): clube, cota do ciclo, dias do plano, mensalidade em aberto e penalidade do site.
 *
 * Fica num lugar só porque a identificação, o cadastro direto e a volta de "Meus agendamentos"
 * montam o cliente a partir da mesma resposta; cada um repetia a lista e um campo novo
 * precisava ser lembrado em todos.
 *
 * Chamado sem cliente (ou com {}), devolve a situação de quem ainda não tem cadastro, usada
 * para limpar os dados ao trocar de cliente.
 */
export const lookupStatusFields = (customer = {}) => {
    const planProducts = customer.planProducts || [];
    // A elegibilidade informada pela API prevalece sobre dados de plano eventualmente antigos.
    const isSubscriber = customer.subscriptionCustomer === true;

    return {
        subscriptionCustomer: isSubscriber,
        planName: isSubscriber ? customer.planName || '' : '',
        planProducts: isSubscriber ? planProducts : [],
        remainingBenefits: customer.remainingBenefits,
        unlimitedBenefits: Boolean(customer.unlimitedBenefits),
        publicBookingDays: customer.publicBookingDays,
        planBenefitDays: isSubscriber ? customer.planBenefitDays || [] : [],
        planOffDayDiscount: customer.planOffDayDiscount,
        clubPaymentOverdue: Boolean(customer.clubPaymentOverdue),
        clubOverdueAmount: customer.clubOverdueAmount,
        // Bloqueio por falta ou por cancelamento em cima da hora. O texto já vem redigido pelo
        // backend, com a data em que o site volta a aceitar, e é o mesmo da recusa no fim.
        onlineBookingBlockedUntil: customer.onlineBookingBlockedUntil || null,
        onlineBookingBlockMessage: customer.onlineBookingBlockMessage || ''
    };
};

/**
 * O bloqueio do site ainda vale?
 *
 * O rascunho do agendamento fica até 24h no navegador e o bloqueio pode acabar antes; sem esta
 * conferência o aviso continuaria na tela depois de liberado. A data chega sem fuso, no horário
 * do estabelecimento, e o navegador a lê como horário local.
 */
export const hasActiveOnlineBookingBlock = (customer, now = new Date()) => {
    if (!customer?.onlineBookingBlockMessage || !customer?.onlineBookingBlockedUntil) {
        return false;
    }
    const blockedUntil = new Date(customer.onlineBookingBlockedUntil);
    // Data ilegível não pode esconder um bloqueio que o backend vai aplicar de qualquer forma.
    return Number.isNaN(blockedUntil.getTime()) || blockedUntil > now;
};
